import { render, staticRenderFns } from "./DeliveryConfirmDrawer.vue?vue&type=template&id=3319aedf&scoped=true"
import script from "./DeliveryConfirmDrawer.vue?vue&type=script&lang=js"
export * from "./DeliveryConfirmDrawer.vue?vue&type=script&lang=js"
import style0 from "./DeliveryConfirmDrawer.vue?vue&type=style&index=0&id=3319aedf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3319aedf",
  null
  
)

export default component.exports
import {QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput})
